<template lang="html">
    <div id="d-evaluations-page">

      <section class="short-info-section-s1">
        <div class="box-top">
          <div class="col-sm-6 col-title">
            <h2>Evaluación cualitativa</h2>
          </div>
        </div>
      </section>

      <section class="evaluations-section" v-if="!loading">
        <b-card no-body>
            <b-tabs class="tab-templ-1" card>
                <b-tab :title="c.title" :active="cInx == 0 ? true : false" v-for="(c, cInx) in rows" :key="'cat'+cInx">

                    <div class="row">
                        <div class="col-sm-6 col-buttons" >
                            Fecha evaluacion Jefe inmediato: <b>{{ c.created_boss }}</b><br>
                            Fecha autoevaluacion: <b>{{ c.created_self }}</b>
                        </div>
                        <div class="col-sm-6 col-buttons" style="text-align: right;" v-if="c.answered == false">
                            <a class="btn btn-s1 bg-red" @click="addModal(cInx)">Registrar autoevaluación</a>
                        </div>
                    </div>

                <!-- Conocimiento -->
                    <div class="row row-evaluation">

                        <div class="col-md-6 col-text">
                            Puntaje total: <b>{{ c.total_score }}</b><br>
                        </div>
                        <div class="col-md-3 col-text">
                            Calificación: <b>{{ c.calification }}</b><br>
                        </div>
                        <div class="col-md-3 col-text" style="text-align: right;">
                          Puntaje obtenido
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Comunicación</h5>
                            <div class="descr">
                                <p>Expresar ideas y transmitir información con claridad, fluidez, precisión y adecuado uso del lenguaje. Escuchar activamente otros puntos de vista y opiniones.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_1 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_1 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_1 + c.assessment_1), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_1 + c.assessment_1) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <!--  -->

                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Trabajo en equipo</h5>
                            <div class="descr">
                                <p>Participar activamente en una meta común, mostrando facilidad para las relaciones interpersonales y capacidad para comprender la repercusión de las propias acciones sobre el éxito de los demás.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_2 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_2 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_2 + c.assessment_2), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_2 + c.assessment_2) }}</span>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Calidad en el trabajo</h5>
                            <div class="descr">
                                <p>Mantener sistemáticamente el enfoque hacia la calidad y la mejora continua en el desempeño del trabajo, conforme a los estándares establecidos.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_3 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_3 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_3 + c.assessment_3), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_3 + c.assessment_3) }}</span>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Resposabilidad</h5>
                            <div class="descr">
                                <p>Comportarse y trabajar conforme a políticas, procedimientos y estándares establecidos por la empresa, asumiendo las consecuencias de los propios actos y decisiones.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_4 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_4 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_4 + c.assessment_4), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_4 + c.assessment_4) }}</span>
                            </vc-donut>
                        </div>
                    </div>

                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Creatividad</h5>
                            <div class="descr">
                                <p>Generar proyectos y desarrollar alternativas de solución innovadoras, utilizando la imaginación y visión de futuro para el logro de resultados.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_5 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_5 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_5 + c.assessment_5), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_5 + c.assessment_5) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Disponibilidad en el trabajo</h5>
                            <div class="descr">
                                <p>Mantener actitudes de servicio, empatía, interés y adaptación a cambios conforme a las necesidades del trabajo, incluso en situaciones de presión.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_6 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_6 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_6 + c.assessment_6), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_6 + c.assessment_6) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Productividad</h5>
                            <div class="descr">
                                <p>Orientar consistentemente el desempeño hacia el logro de resultados conforme a estándares y procedimientos establecidos.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_7 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_7 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_7 + c.assessment_7), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_7 + c.assessment_7) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Actitud de servicio</h5>
                            <div class="descr">
                                <p>Buscar permanentemente la satisfacción de clientes internos y externos mediante el conocimientos de sus requerimientos y necesidades, resolviendo problemas y proporcionando seguimiento.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_8 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_8 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_8 + c.assessment_8), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_8 + c.assessment_8) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Conocimientos técnicos</h5>
                            <div class="descr">
                                <p>Conocer conceptos técnicos, productos, tecnología, herramientas de trabajo y procesos propios del puesto para resolver dudas, problemas técnicos, dar recomendaciones y mantenerse actualizado en sus funciones diarias.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_9 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_9 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_9 + c.assessment_9), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_9 + c.assessment_9) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                    <div class="row row-evaluation">
                        <div class="col-md-6 col-text">
                            <h5 class="title">Relaciones interpersonales</h5>
                            <div class="descr">
                                <p>Establecer contactos interpersonales de manera armoniosa y mantener actitudes positivas de empatía, cordialidad e interés por los demás.</p>
                            </div>
                        </div>
                        <div class="col-md-3 col-chart">
                            Autoevaluación: <b>{{ c.self_appraisal_10 }}</b><br>
                            Evaluación jefe inmediato: <b>{{ c.assessment_10 }}</b>
                        </div>
                        <div class="col-md-3 col-chart">
                            <vc-donut :total="10" :size="150" unit="px" :thickness="18" :sections="[{ value: parseInt(c.self_appraisal_10 + c.assessment_10), color: '#8a0e0a' }]">
                            <span class="chart-number">{{ parseInt(c.self_appraisal_10 + c.assessment_10) }}</span>
                            </vc-donut>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
      </section>

      <section class="evaluations-section" v-else>
        <div class="box-results"  style="padding-top: 150px;text-align: center;">
          <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
        </div>
      </section>

      <b-modal modal-class="modal-request-s1" ref="modal-request" title="Evalúa las siguientes competencias de acuerdo a los niveles establecidos." size="lg" centered hide-footer>
        <p>Evalua cada competencia de acuerdo a los criterios establecidos siguientes;</p>
        <p>1. Deficiente | 2. Insuficiente | 3. Satisfactorio |  4. Sobresaliente | 5. Excelente</p>
           <hr>
        <b-form @submit="onSubmitForm" class="row">
            <div class="col-lg-8">
                <p><b>Comunicación</b><br>Expresar ideas y transmitir información con claridad, fluidez, precisión y adecuado uso del lenguaje. Escuchar activamente otros puntos de vista y opiniones.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(1)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_1"
                      type="number"
                      min="1"
                      max="5"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Trabajo en equipo</b><br>Participar activamente en una meta común, mostrando facilidad para las relaciones interpersonales y capacidad para comprender la repercusión de las propias acciones sobre el éxito de los demás.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(2)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_2"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Calidad en el trabajo</b><br>Mantener sistemáticamente el enfoque hacia la calidad y la mejora continua en el desempeño del trabajo, conforme a los estándares establecidos.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(3)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_3"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Resposabilidad</b><br>Comportarse y trabajar conforme a políticas, procedimientos y estándares establecidos por la empresa, asumiendo las consecuencias de los propios actos y decisiones.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(4)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_4"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Creatividad</b><br>Generar proyectos y desarrollar alternativas de solución innovadoras, utilizando la imaginación y visión de futuro para el logro de resultados.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(5)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_5"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Disponibilidad en el trabajo</b><br>Mantener actitudes de servicio, empatía, interés y adaptación a cambios conforme a las necesidades del trabajo, incluso en situaciones de presión.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(6)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_6"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Productividad</b><br>Orientar consistentemente el desempeño hacia el logro de resultados conforme a estándares y procedimientos establecidos.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(7)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_7"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Actitud de servicio</b><br>Buscar permanentemente la satisfacción de clientes internos y externos mediante el conocimientos de sus requerimientos y necesidades, resolviendo problemas y proporcionando seguimiento.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(8)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_8"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Conocimientos técnicos</b><br>Conocer conceptos técnicos, productos, tecnología, herramientas de trabajo y procesos propios del puesto para resolver dudas, problemas técnicos, dar recomendaciones y mantenerse actualizado en sus funciones diarias.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(9)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_9"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

            <div class="col-lg-8">
                <p><b>Relaciones interpersonales</b><br>Establecer contactos interpersonales de manera armoniosa y mantener actitudes positivas de empatía, cordialidad e interés por los demás.</p>
            </div>
            <div class="col-lg-4 col-autoev">
                <fieldset class="form-group mb-0 form-group-s1">
                  <legend class="bv-no-focus-ring col-form-label pt-0">Autoevaluación <i class="fas fa-info-circle btn-show-info" @click="showInfoModal(10)"></i></legend>
                </fieldset>
                <b-form-group class="mb-4 form-group-s1">
                  <b-form-input
                      v-model="formModal.self_appraisal_10"
                      type="text"
                      placeholder=""
                      required
                  ></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12"><hr></div>

          <b-button type="submit" class="btn-s1 bg-red btn-lg mt-2 w-100">Enviar</b-button>
        </b-form>
      </b-modal>

      <b-modal modal-class="modal-request-s1" ref="modal-info-autoev" title="Autoevaluación" centered hide-footer>
        <div class="box-info">
          <!-- COMUNICACIÓN -->
          <div v-if="iModal == 1">
            <h3 class="title-i">(COMUNICACIÓN)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Presenta dificultades para comunicarse abierta y claramente. Sus ideas son difíciles de entender y no cuenta con disposición para escuchar a otros.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Se comunica cuando es requerido, necesita apoyo para transmitir claramente sus ideas. En ocasiones escucha otros puntos de vista.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Generalmente transmite sus ideas e información de manera clara y precisa. Frecuentemente muestra apertura para escuchar atentamente a los demás.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Muestra habilidades para realizar presentaciones y comunicarse con diversos tipos de personas. Transmite correctamente mensajes y escucha activamente.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Se comunica de manera clara y objetiva en todo momento. Siempre escucha atentamente a los demás y toma en cuenta sus opiniones. Facilita la comunicación en ambos sentidos.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- TRABAJO EN EQUIPO -->
          <div v-if="iModal == 2">
            <h3 class="title-i">(TRABAJO EN EQUIPO)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Generalmente trabaja de manera individual, mostrando poco interés por involucrarse en proyectos grupales.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Se integra a equipos de trabajo cuando se le solicita, mostrando poca participación e involucramiento.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Participa activamente en proyectos que requieren su integración a equipos de trabajo y muestra interés por lograr un objetivo compartido.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Muestra favorables habilidades interpersonales y de colaboración. Aporta información relevante para el cumplimiento de objetivos comunes.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Propicia la participación en proyectos grupales. Busca la colaboración y complementariedad entre los miembros de su grupo, aprovechando lo mejor de cada uno para garantizar el logro de metas comunes. Armoniza las relaciones entre los miembros del equipo.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- CALIDAD EN EL TRABAJO -->
          <div v-if="iModal == 3">
            <h3 class="title-i">(CALIDAD EN EL TRABAJO)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Constantemente comete errores e ignora los estándares de calidad correspondientes a los procesos de trabajo.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Con cierta frecuencia comete errores y corrige con oportunidad para cumplir con los requerimientos del trabajo asignado.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                En algunas ocasiones requiere corregir su trabajo. Se apega a políticas, normas y estándares de calidad de su proceso de trabajo.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Generalmente realiza su trabajo conforme a lo establecido y busca alternativas para mejorar la calidad en las tareas asignadas.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Agrega valor y dá algo más de lo que se le solicita en la realización de su trabajo, logra perfeccionar su trabajo y se asegura de cumplir con los estándares de calidad.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- RESPONSABILIDAD -->
          <div v-if="iModal == 4">
            <h3 class="title-i">(RESPONSABILIDAD)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Frecuentemente muestra indiferencia hacia el cumplimiento de normas y procedimientos, presenta regularmente retardos e inasistencias, se ha hecho acreedor a llamadas de atención por su comportamiento. Descuida su presentación.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Ocasionalmente presenta retardos o inasistencias, rara vez falla en su presentación. Corrige inmediatamente su comportamiento si se le reprende.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Es puntual y rara vez falta a su trabajo. Toma decisiones y se desempeña conforme a normas y procedimientos. Cuida los lineamientos de presentación que establece la empresa.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Se interesa por conservar un perfecto record de asistencia y puntualidad. Cumple con los reglamentos y procedimientos en todas sus acciones y decisiones. Su presentación es siempre la óptima.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Siempre llega con anticipación a su horario de entrada y promueve con sus compañeros el respeto a las disposiciones y normas. Toma decisiones y actúa en todo momento conforme a los lineamientos de la empresa. Excelente presentación.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- CREATIVIDAD -->
          <div v-if="iModal == 5">
            <h3 class="title-i">(CREATIVIDAD)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Muestra indiferencia por encontrar nuevos caminos en la solución de problemas. Sus aportaciones para la mejora son nulas.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Sus aportaciones a la solución de problemas son inconsistentes con las necesidades de la situación y carecen de innovación.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Proyecta interés por desarrollar ideas novedosas y eficientes para la mejora de su trabajo. Algunas de sus aportaciones se han aplicado en la solución de problemas.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Presenta frecuentemente ideas y proyectos innovadores, los cuales han sido eficientes en la mejora de los procesos y en la solución de problemas.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Siempre se basa en diferentes enfoques y alternativas al estudiar una situación. Desarrolla proyectos e ideas innovadoras con cursos de acción eficaces para la mejora.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- DISPONIBILIDAD EN EL TRABAJO -->
          <div v-if="iModal == 6">
            <h3 class="title-i">(DISPONIBILIDAD EN EL TRABAJO)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Se resiste a cambios o nuevos sistemas, ante situaciones de presión muestra molestia y no responde a requerimientos de tiempo y colaboración cuando es necesario.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Manifiesta renuencia al solicitársele adecuarse a cambios, disponibilidad de horario e integración con compañeros de trabajo.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Se adapta a situaciones cambiantes, muestra actitud de servicio e interés ante diversas necesidades de trabajo. Dispone de su tiempo cuando se requiere extender el horario de trabajo.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Rápidamente de adapta y muestra interés ante cambios y situaciones de presión. Manifiesta disposición y actitudes positivas en diferentes circunstancias.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Maneja adecuadamente situaciones de presión sin afectar su desempeño. Ágilmente se adecúa a nuevos sistemas y se interesa por realizar mejoras. En todo momento es notable su disposición y actitud.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- PRODUCTIVIDAD -->
          <div v-if="iModal == 7">
            <h3 class="title-i">(PRODUCTIVIDAD)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Su productividad es baja debido a desorganización en su trabajo y desconocimiento de los objetivos a lograr. Necesita supervisión en todo momento.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Presenta rendimiento inferior al mínimo requerido. Requiere administrar su trabajo y tiempo con base en los resultados que se esperan de su desempeño.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Mantiene niveles de productividad conforme a los estándares y objetivos establecidos.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Supera los estándares de productividad y calidad establecidos en sus procesos de trabajo. Dirige sus esfuerzos hacia el logro de objetivos.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Su desempeño es altamente productivo, cuenta con iniciativa para nuevos proyectos y consistentemente cumple con los resultados esperados.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- ACTITUD DE SERVICIO -->
          <div v-if="iModal == 8">
            <h3 class="title-i">(ACTITUD DE SERVICIO)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Desconoce las necesidades y requerimientos de sus clientes, proyecta poco interés en la solución de sus problemas.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Intenta atender los requerimientos de sus clientes pero requiere supervisión para proporcionar el servicio solicitado.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Muestra interés por conocer las exigencias de los clientes, solicita apoyo para proporcionar servicio de calidad y resolver problemas.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Desempeña su trabajo pensando en la mejor forma de satisfacer los requerimientos de sus clientes. Mantiene actitudes de amabilidad, interés y colaboración en cada oportunidad de prestar sus servicios.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Identifica y analiza las necesidades de sus clientes, presenta soluciones y da seguimiento. Trabaja orientado hacia la calidad en el servicio.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- CONOCIMIENTOS TÉCNICOS -->
          <div v-if="iModal == 9">
            <h3 class="title-i">(CONOCIMIENTOS TÉCNICOS)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Requiere actualización en los conocimientos propios del puesto. Muestra ineficiencia en el manejo de herramientas de trabajo (computación, idiomas, etc.).
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                Conoce conceptos, procesos y herramientas básicas para el desarrollo de su puesto. Necesita apoyo para resolver dudas y proporcionar sugerencias.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Domina los conocimientos, procesos y herramientas necesarios para realizar eficazmente su trabajo. Resuelve dudas y da sugerencias cuando se le solicitan.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Frecuentemente se integra a programas de capacitación para mejorar sus conocimientos y dominio de herramientas de trabajo. Cuenta con iniciativa para presentar recomendaciones.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Se actualiza constantemente en conocimientos de procesos, productos, tecnología y herramientas para desempeñar eficazmente su trabajo. Siempre muestra disposición para compartir conocimientos y aportar recomendaciones.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- RELACIONES INTERPERSONALES -->
          <div v-if="iModal == 10">
            <h3 class="title-i">(RELACIONES INTERPERSONALES)</h3>

            <h5 class="title">1 DEFICIENTE</h5>
            <h6 class="subtitle">(2 puntos)</h6>
            <div class="info">
              <p>
                Presenta dificultades y poco interés por relacionarse con clientes, proveedores y compañeros de trabajo. Generalmente trabaja aisladamente.
              </p>
            </div>

            <br />
            <h5 class="title">2 INSUFICIENTE</h5>
            <h6 class="subtitle">(4 puntos)</h6>
            <div class="info">
              <p>
                En ocasiones se integra a actividades que requieren relacionarse con personas. Se recomienda que desarrolle actitudes de amabilidad en su trato con los demás.
              </p>
            </div>

            <br />
            <h5 class="title">3 SATISFACTORIO</h5>
            <h6 class="subtitle">(6 puntos)</h6>
            <div class="info">
              <p>
                Generalmente se relaciona adecuadamente con las personas y es cordial en su trato con otros.
              </p>
            </div>

            <br />
            <h5 class="title">4 SOBRESALIENTE</h5>
            <h6 class="subtitle">(8 puntos)</h6>
            <div class="info">
              <p>
                Proyecta un desarrollo favorable de sus habilidades sociales, fácilmente establece contactos con diferentes tipos de personas. Muestra actitudes positivas ante diversas situaciones.
              </p>
            </div>

            <br />
            <h5 class="title">5 EXCELENTE</h5>
            <h6 class="subtitle">(10 puntos)</h6>
            <div class="info">
              <p>
                Fomenta actitudes de empatía y cordialidad en su equipo de trabajo. Se integra a labores que implican trato constante con las personas. En todo momento muestra interés por los  demás.
              </p>
            </div>
          </div>
          <!--  -->
        </div>
      </b-modal>

    </div>
  </template>

  <script>
  export default {
    data() {
      return {
        iModal: null,

        formModal: {
          comentarios: null,
        },

        conocimientoObj: [{ value: 55, color: '#8a0e0a' }],
        eticaObj: [{ value: 70, color: '#8a0e0a' }],
        desempenoObj: [{ value: 60, color: '#8a0e0a' }],
        puntualidadObj: [{ value: 100, color: '#8a0e0a' }],
        rows:[],
        loading:false,
      };
    },

    methods: {
        addModal(indx){
            this.formModal = this.rows[indx];
            this.$refs['modal-request'].show();
        },
        showInfoModal(idx) {
          this.iModal = idx;
          this.$refs['modal-info-autoev'].show();
        },
        onSubmitForm(event) {
            event.preventDefault();

            axios.post(tools.url("/api/qualitative"),this.formModal).then((response)=>{
                this.getRows();
                this.$refs['modal-request'].hide();
            }).catch(()=>{});
        },
        getRows(){
            this.loading = true;
            axios.get(tools.url("/api/qualitative")).then((response)=>{
                this.rows = response.data;
                this.loading = false;
            }).catch(()=>{
                this.loading = false;
            });
        },

    },
    mounted(){
      this.getRows();
    }
  }
  </script>
